import { ReadMoreBtn } from 'vendor-js/read-more';
const listDetail = document.getElementById('js--list-detail');

if(listDetail) {
    new ReadMoreBtn ({
        selectors: listDetail,
        readMoreBtnText: 'Read More',
        length: 470,
        sliceLength: 470,
    });
}

$('#js--list_search_box').keyup(event => {
    $('.js--list_product').each((index, element) => {
        const input = $(event.currentTarget).val().trim(), searchData = $(element).attr('data-search');
        if (searchData.indexOf(input) > -1
            || searchData.toUpperCase().indexOf(input.toUpperCase()) > -1) {
            $(element).show();
        } else {
            $(element).hide();
        }
    });
});
